import { AppUser } from '@eventr/common'
import { Avatar } from '@mui/material'
import { FC } from 'react'
import { IRCUser } from '../../data/Rocket'
import { useBoundStore } from '../../state/bound.store'

type props = {
    user?: AppUser
    sideLength?: number
    rcUser?: IRCUser
}

export const MemberProfilePic: FC<props> = ({ user, sideLength, rcUser }) => {
    function stringToColor(string: string) {
        let hash = 0
        let i

        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash)
        }

        let color = '#'

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff
            color += `00${value.toString(16)}`.slice(-2)
        }
        /* eslint-enable no-bitwise */

        return color
    }

    const color = stringToColor(user?.email ?? rcUser?.username ?? '')

    const drawInitials = () => {
        return (
            (user && user.firstName && user.lastName) || (rcUser && rcUser.name)
        )
    }
    const getInitials = () => {
        if (user) {
            return [
                user?.firstName[0]?.toUpperCase() ?? '',
                user?.lastName[0]?.toUpperCase() ?? '',
            ].join('')
        } else if (rcUser) {
            const userFromName = useBoundStore
                .getState()
                .getUserFromName(rcUser.name)
            if (userFromName) {
                return [
                    userFromName?.firstName[0]?.toUpperCase() ?? '',
                    userFromName?.lastName[0]?.toUpperCase() ?? '',
                ].join('')
            }
        }
        /// Below has not been fixed but should not be used. will split the name into many parts not just 2 initials.
        if (rcUser) {
            return rcUser?.name
                .split(' ')
                .map((e) => e[0].toUpperCase())
                .join('')
        }
        return ''
    }

    const getPictureUrl = () => {
        if (user) {
            return (
                user?.profilePicSizes?.tiny?.url ??
                user?.profilePicSizes?.medium?.url ??
                user?.profilePicUrl ??
                rcUser?.customFields?.avatarUrl ??
                undefined
            )
        }
    }
    return (
        <div
            style={{
                backgroundColor: `${color}30`,
                borderRadius: '50%',
            }}
        >
            <Avatar
                sx={{
                    height: `${sideLength ? sideLength : 32}px`,
                    width: `${sideLength ? sideLength : 32}px`,
                    fontSize: (sideLength ?? 0) > 40 ? '150%' : '14px',
                    fontFamily: 'Inter-100-500',
                    fontWeight: 500,
                    color: color,
                    bgcolor: `transparent`,
                    filter: 'brightness(80%)',
                    transition: '0.5s',
                }}
                src={getPictureUrl()}
            >
                {drawInitials() ? (
                    getInitials()
                ) : (
                    <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clipPath="url(#clip0_4067_54)">
                            <rect
                                width="32"
                                height="32"
                                rx="16"
                                fill={color}
                                fillOpacity="0.2"
                            />
                            <path
                                d="M5.83131 23.6584C6.45669 20.9324 8.88257 19 11.6794 19H20.3206C23.1174 19 25.5433 20.9324 26.1687 23.6584L27.3157 28.6584C28.1778 32.4161 25.323 36 21.4677 36H10.5323C6.677 36 3.82219 32.4161 4.68425 28.6584L5.83131 23.6584Z"
                                fill={color}
                            />
                            <circle cx="16" cy="12" r="6" fill={color} />
                        </g>
                        <defs>
                            <clipPath id="clip0_4067_54">
                                <rect
                                    width="32"
                                    height="32"
                                    rx="16"
                                    fill={color}
                                />
                            </clipPath>
                        </defs>
                    </svg>
                )}
            </Avatar>
        </div>
    )
}
